import React from 'react';
import Link from 'gatsby-link'
import Navigation from '../components/Navigation'

export default function Categories({ data, pathContext }) {
  const { posts, post, category } = pathContext;
  if (category) {
    return (
      <div>
        <Navigation />
        <h1>
          {post.length} post{post.length === 1 ? '' : 's'} categorised with {category}
        </h1>
        {data.allMarkdownRemark.edges.map(({ node }) =>
        <div>
          {node.frontmatter.categories.includes(category) && <div key={node.id}>
            <Link
              to={ `post${node.fields.slug}` }
              css={{ textDecoration: 'none', color: 'inherit' }}
            >
            <h3>
              {node.frontmatter.title}{" "}
              <span color="#BBB">— {node.frontmatter.date}</span>
            </h3>
            </Link>
            <p>
              {node.excerpt}
            </p>
          </div> }
          </div>
        )}
        <Link to="/categories">
          All categories
        </Link>
      </div>
    );
  }
  return (
    <div>
      <Navigation />
      <h1>Categories</h1>
      <ul className="categories">
        {Object.keys(posts).map(categoryName => {
          const categories = posts[categoryName];
          return (
            <li key={categoryName}>
              <Link to={`/category/${categoryName}`}>
                {categoryName}
              </Link>
            </li>
          );
        })}
      </ul>
      <Link to="/blog">
        All posts
      </Link>
    </div>
  );
}

export const query = graphql`
query CategoryQuery {
  allMarkdownRemark(sort: {fields: [frontmatter___date], order: DESC}) {
    totalCount
    edges {
      node {
        id
        frontmatter {
          title
          date(formatString: "DD MMMM, YYYY")
          categories
        }
        fields {
          slug
        }
        excerpt
      }
    }
  }
}
`


// WEBPACK FOOTER //
// ./src/templates/categories.js